// src/App.js
import React from "react";
import "./App.css";
import LessonGenIndex from "./LessonGenIndex";
import SignIn from "./SignIn";
import PurchaseCredits from "./PurchaseCredits";
import Support from "./Support";
import Settings from "./Settings";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import LessonSummary from "./LessonSummary";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import DashboardLayout from "./DashboardLayout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import CreateLesson from "./CreateLesson";


// import Piano from "./Piano";

import Vizzy from "./Vizzy";
import Create from "./Create";


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>

        <Route path="/" element={<Vizzy />} />
        <Route path="/create" element={<Create />} />
          {/* <Route path="/piano" element={<Piano />} /> */}

          {/* <Route path="/" element={<LessonGenIndex />} /> */}
          {/* <Route path="/login" element={<PublicRoute> <SignIn /> </PublicRoute>} />

          <Route path="/termsofservice" element={<TermsOfService />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          <Route path="/dashboard" element={<ProtectedRoute> <DashboardLayout /> </ProtectedRoute>} >
            <Route index element={<CreateLesson />} />
            <Route path="lesson/:lessonId" element={<LessonSummary />} />
            <Route path="purchase" element={<PurchaseCredits />} />
            <Route path="support" element={<Support />} />
            <Route path="settings" element={<Settings />} />
          </Route> */}


          <Route path="*" element={<div>Not Found</div>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
